import { AppEnvironment } from '@dev-portal/environments';

export const baseEnvironmentValues: Pick<AppEnvironment, 'paths' | 'version'> = {
  version: '1.2.0',
  paths: {
    images: '/assets/images'
  }
};

export const scope: string =
  'openid profile offline_access role oidc-application:read oidc-application:write';
